var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-interface"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.707 7.70709L13.4139 12.0001L17.707 16.2931C18.0976 16.6837 18.0976 17.3165 17.707 17.7072C17.5117 17.9025 17.2557 18.0002 16.9999 18.0002C16.7441 18.0002 16.4882 17.9025 16.2929 17.7072L11.9999 13.4142L7.70695 17.7072C7.51165 17.9025 7.25575 18.0002 6.99995 18.0002C6.74415 18.0002 6.48825 17.9025 6.29295 17.7072C5.90235 17.3166 5.90235 16.6838 6.29295 16.2931L10.586 12.0001L6.29295 7.70709C5.90235 7.31649 5.90235 6.68369 6.29295 6.29299C6.68355 5.90229 7.31635 5.90239 7.70705 6.29299L12.0001 10.586L16.293 6.29299C16.6837 5.90239 17.3164 5.90239 17.7071 6.29299C18.0978 6.68359 18.0976 7.31639 17.707 7.70709Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.58becf182da97fd96ca81014225b9c39.svg";
export { ForwardRef as ReactComponent };